"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reactionFragmentation = reactionFragmentation;
const mf_parser_1 = require("mf-parser");
const openchemlib_1 = __importDefault(require("openchemlib"));
const openchemlib_utils_1 = require("openchemlib-utils");
const getDatabase_1 = require("./database/getDatabase");
const getMasses_1 = require("./utils/getMasses");
/**
 * @description Fragment a molecule by applying reactions from a custom database of reactions
 * @param {import('openchemlib').Molecule} oclMolecule - The OCL molecule to be fragmented
 * @param {Object}  [options={}]
 * @param {('esi'|'ei')[]}  [options.ionizations=['esi']] - The ionization technique to be used
 * @param {('positive'|'negative')[]}  [options.modes=['positive']] - The ionization mode to be used
 * @param {number}  [options.maxDepth=5] - The maximum depth of the overall fragmentation tree
 * @param {number}  [options.limitReactions=200] - The maximum number of reactions to be applied to each branch
 * @param {string}  [options.dwar] - The dwar entry to be used, if not provided, the default one will be used
 * @param {number}  [options.maxIonizations=1] - The maximum depth of the ionization tree
 * @param {number}  [options.minIonizations=1] - The minimum depth of the ionization tree
 * @param {number}  [options.minReactions=0] - The minimum depth of the reaction tree
 * @param {number}  [options.maxReactions=3] - The maximum depth of the reaction tree
 * @returns {object} In-Silico fragmentation results with the following properties:
 * - masses: array of monoisotopic masses
 * - trees: array of fragmentation trees
 * - validNodes: nodes without dead branches
 */
function reactionFragmentation(oclMolecule, options = {}) {
    const { ionizations = ['esi'], modes = ['positive'], dwar, maxDepth = 5, limitReactions = 200, minIonizations = 1, maxIonizations = 1, minReactions = 0, maxReactions = 3, } = options;
    const reactions = new openchemlib_utils_1.Reactions(openchemlib_1.default, {
        moleculeInfoCallback: (molecule) => {
            // @ts-ignore
            const mf = (0, openchemlib_utils_1.getMF)(molecule).mf;
            const mfInfo = new mf_parser_1.MF(mf).getInfo();
            return {
                mf,
                mw: mfInfo.mass,
                em: mfInfo.monoisotopicMass,
                mz: mfInfo.observedMonoisotopicMass,
                charge: mfInfo.charge,
            };
        },
        maxDepth,
        limitReactions,
        skipProcessed: true,
    });
    reactions.appendHead([oclMolecule]);
    reactions.applyOneReactantReactions((0, getDatabase_1.getDatabase)({
        kind: ['ionization'],
        ionizations,
        modes,
        dwar,
    }), {
        min: minIonizations,
        max: maxIonizations,
    });
    const reactionDb = (0, getDatabase_1.getDatabase)({
        kind: ['reaction'],
        ionizations,
        modes,
        dwar,
    });
    for (let i = 1; i <= maxReactions; i++) {
        let min = 1;
        if (minReactions < i + 1) {
            min = 0;
        }
        reactions.applyOneReactantReactions(reactionDb, {
            min,
            max: 1,
        });
    }
    const trees = reactions.trees;
    const validNodes = reactions.getValidNodes();
    const masses = (0, getMasses_1.getMasses)(validNodes);
    return {
        trees,
        validNodes,
        masses,
        reactions,
    };
}
//# sourceMappingURL=reactionFragmentation.js.map